export default function HackClubLogo({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      preserveAspectRatio="xMidYMid meet"
      width="100%"
      height="100%"
      overflow="visible"
      style={{ display: "block" }}
      viewBox="0 0 85 104"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Logo">
        <path
          id="Vector 2"
          d="M30.3561 33.1252H13.5518V20.7369L6.85453e-07 33.1252L6.85453e-07 18.4747L18.2453 0L25.7485 0L43.3659 16.9666V33.3406L30.3561 20.7369V33.1252Z"
          fill="currentColor"
        />
        <path
          id="Vector 3"
          d="M71.5538 70.7748H54.7495V83.1631L41.1977 70.7748V85.4253L59.443 103.9H66.9462L84.5636 86.9334V70.5594L71.5538 83.1631V70.7748Z"
          fill="currentColor"
        />
        <path
          id="h"
          d="M71.5538 65.3309V86.7181H54.3833V63.9816C54.3833 60.5399 53.7933 57.7631 52.6132 55.6511C51.0791 52.6787 48.1682 51.1926 43.8805 51.1926C39.4354 51.1926 36.0525 52.6787 33.7316 55.6511C31.4501 58.5844 30.3562 62.7887 30.3562 68.2642V102.877H13.5519V32.856H30.3562V41.8758C31.9824 40.3966 33.0779 40.2206 36.319 39.3422C41.4524 37.9509 45.3556 37.2889 48.8959 37.2889C52.8689 37.2889 56.4682 37.9733 59.6938 39.3422C62.9587 40.711 65.6336 42.8034 67.7185 45.6194C69.4886 48.0051 70.5704 50.469 70.9637 53.0112C71.3571 55.5142 71.5538 59.6208 71.5538 65.3309Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}
